import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { LinkTargetType } from '@savebetter/components';

import { PageSectionProps } from './PageSection';

type StoryblokIconOptions = 'Facebook' | 'LinkedIn' | 'Twitter' | 'Instagram' | 'Youtube';

interface Link extends SbBlokData {
  url: string;
  icon: StoryblokIconOptions;
  target?: LinkTargetType;
}

interface Blok extends SbBlokData {
  title: string;
  links: Link[];
}

interface SocialBoxProps extends PageSectionProps {
  blok: Blok;
}

export const SocialBox: FunctionComponent<React.PropsWithChildren<SocialBoxProps>> = ({ blok }) => {
  const { title, links } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      {title}
      <ul>
        {links.map(link => {
          const { _uid, url, icon, target } = link;

          return (
            <li {...storyblokEditable(link)} key={_uid}>
              <a href={url} target={target}>
                {icon}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
